// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route:
//
//   ...
//   component: () => import(/* webpackChunkName: "about" */ '@./views/About.vue')
//   ...
//
// which is lazy-loaded when the route is visited.

import Vue from 'vue'
import VueRouter from 'vue-router'
import { Auth } from 'aws-amplify'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    children: [
      {
        name: 'Dashboard',
        path: '/dashboard',
        component: () => import('@/views/Dashboard.vue')
      },
      {
        name: 'Users',
        path: '/users',
        component: () => import('@/views/Users.vue')
      },
      {
        name: 'Lists',
        path: '/lists',
        component: () => import('@/views/Lists.vue')
      },
      {
        name: 'Orders',
        path: '/orders',
        component: () => import('@/views/Orders.vue')
      },
      {
        name: 'Wallets',
        path: '/wallets',
        component: () => import('@/views/Wallets.vue')
      },
      {
        name: 'Withdraws',
        path: '/withdraws',
        component: () => import('@/views/Withdraws.vue')
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, _, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (!requiresAuth) {
    next()
    return
  }

  Auth.currentSession()
    .then(() => {
      store.dispatch('setIsAuthenticated', true)
      next()
    })
    .catch(() => {
      store.dispatch('setIsAuthenticated', false)
      next('/login')
    })
})

export default router
